/** Removes ?token= from the address bar so the sign-in token isn't kept in history. */
export function stripTokenFromUrl(): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has("token")) {
    return;
  }
  url.searchParams.delete("token");
  window.history.replaceState({}, "", url.toString());
}
